import getThemeFromProps from './getThemeFromProps';

const getInteractionsBasedOnProps = (props) => {
  const theme = getThemeFromProps(props);

  return theme.interactions;
};

export default getInteractionsBasedOnProps;
